<template>
  <div>
    <ListLayout
      :title="`${tripPlanningModule.driverZone}`"
      :tableData="driverZoneList"
      :tableHeader="tableHeaders"
      :total="totalItems"
      :context="context"
      @getList="getDriverZoneList"
    >
      <template #listAction>
        <PrimaryButton
          id="driverZoneAdd"
          @click="$router.push({ name: 'add-driver-zone' })"
          v-if="permissions && permissions.add"
          :name="`Add ${tripPlanningModule.driverZone}`"
          icon="mdi-plus"
          iconSize="x-large"
        >
        </PrimaryButton>
      </template>
    </ListLayout>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import DriverZoneButton from "@/components/Button/DriverZoneButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { tripPlanningModule } from "@/utils/moduleMapping";

export default {
  components: {
    DriverZoneButton,
    ListLayout,
  },
  data() {
    return {
      tripPlanningModule,
      permissions: null,
      openDownloadDialog: false,
      sorting: {},
      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,
      filters: {},
      driverZoneList: [],
      openDriverZoneDetail: false,
      selectedId: null,
      headerSelected: [
        {
          headerName: "Name",
          field: "name",
          sortable: true,
        },
        {
          headerName: "Description",
          field: "description",
          sortable: true,
          tooltipField: "description",
        },
      ],

      isEditing: false,
      showDriverZoneForm: false,
      selectedDriverZoneID: null,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 110,
          sortable: false,
          width: 110,
          cellRenderer: "DriverZoneButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getDriverZoneList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }

      this.$api.driverZone
        .getDriverZoneList(params)
        .then((res) => {
          this.driverZoneList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    deleteDriverZone(id) {
      bus.$emit("showLoader", true);
      this.$api.driverZone
        .deleteDriverZoneObject(id)
        .then(() => {
          bus.$emit("showToastMessage", {
            message: "Driver Zone deleted successfully!",
            color: "success",
          });
          this.getDriverZoneList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showToastMessage", {
            message: "Couldn't delete Driver Zone!",
            color: "error",
          });
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("trip_planning");
  },
};
</script>
